// extracted by mini-css-extract-plugin
module.exports = {"Container":"SelectedBundlesList_Container__1379m"};